import { motion } from "framer-motion";
import { Home, Building2, Briefcase, HardHat, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: "home",
    title: "Home Cleaning",
    icon: Home,
    desc: "Weekly, bi-weekly, deep cleans. We treat your home like our own.",
    img: "https://images.pexels.com/photos/5998138/pexels-photo-5998138.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "office",
    title: "Office Cleaning",
    icon: Briefcase,
    desc: "After-hours service so your team walks into a spotless space.",
    img: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "commercial",
    title: "Commercial",
    icon: Building2,
    desc: "Retail, clinics, gyms, lobbies. Compliance-grade sanitization.",
    img: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "construction",
    title: "Construction Cleanup",
    icon: HardHat,
    desc: "Post-build dust, debris and detailing. Move-in ready, fast.",
    img: "https://images.pexels.com/photos/7108785/pexels-photo-7108785.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export default function Services({ onBook }) {
  return (
    <section id="services" data-testid="services-section" className="pc-section bg-white">
      <div className="pc-container">
        <div className="flex flex-col items-start gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="eyebrow text-[var(--pc-green-hover)]">What we clean</div>
            <h2 className="font-display mt-3 max-w-2xl text-4xl font-black tracking-tighter sm:text-5xl">
              Four services. One uncompromising standard.
            </h2>
          </div>
          <p className="max-w-md text-base text-black/60">
            Every Pristyn job is custom-quoted — no two spaces are the same.
            Tell us about yours and we'll handle the rest.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.button
                key={s.id}
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                onClick={onBook}
                className="group relative overflow-hidden rounded-3xl border border-black/10 bg-white text-left transition-all hover:-translate-y-1 hover:border-[var(--pc-green)] hover:shadow-[0_25px_60px_-30px_rgba(0,230,118,0.45)]"
              >
                <div className="relative h-64 overflow-hidden md:h-72">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
                  <div className="absolute left-5 top-5 grid h-12 w-12 place-items-center rounded-full bg-white/90 text-black backdrop-blur">
                    <Icon size={22} strokeWidth={2} />
                  </div>
                </div>
                <div className="flex items-start justify-between gap-6 p-6 md:p-8">
                  <div>
                    <h3 className="font-display text-2xl font-bold tracking-tight md:text-3xl">
                      {s.title}
                    </h3>
                    <p className="mt-2 max-w-md text-sm text-black/60 md:text-base">
                      {s.desc}
                    </p>
                  </div>
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-black/15 transition-all group-hover:rotate-45 group-hover:border-[var(--pc-green)] group-hover:bg-[var(--pc-green)]">
                    <ArrowUpRight size={20} />
                  </span>
                </div>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
